import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import PaymentMethod from './PaymentMethod';

function Payment() {
  return (
    <Routes>
      <Route path="method" element={<PaymentMethod />} />
    </Routes>
  );
}

export default Payment;
